import { AuthPage } from '@pages/auth';
import { EventsPage } from '@pages/events';
import { NewEvent } from '@pages/new-event';
import { EventPage } from '@pages/event';
import { QrPage } from '@pages/qr-page';
import { QrPageAdmin } from '@pages/qr-page-admin';
import { ErrorPage } from '@pages/error-page';
import { ErrorPageForRemote } from '@pages/error-page-for-remote';
import { UnknownErrorPage } from '@pages/unknown-error';
import { NotFoundPage } from '@pages/not-found-page';
import { InvitePage } from '@pages/invite-page';
import { FormPage } from '@pages/form-page';
import {
  AppRoutes,
  getRouteAuth,
  getRouteEvents,
  getRouteEventCreate,
  getRouteEventDetails,
  getRouteQr,
  getRouteInvite,
  getRouteForm,
  getRouteQrAdmin,
  getRouteError,
  getRouteErrorQrRemote,
  getRouteUnknownError,
  getRouteUncaughtError,
} from '@shared/constants/router';
import { BasicLayout } from '@shared/layouts/BasicLayout';
import { AuthLayout } from '@shared/layouts/AuthLayout';
import { MainLayout } from '@shared/layouts/MainLayout';
import { AppRoutesProps } from '@shared/types/router';
import { ErrorPageUncaughtError } from '@pages/error-page-invalid-ticket';

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
  [AppRoutes.AUTH]: {
    path: getRouteAuth(),
    element: <AuthPage />,
    layout: AuthLayout,
  },
  [AppRoutes.EVENTS]: {
    path: getRouteEvents(),
    element: <EventsPage />,
    authOnly: true,
    layout: MainLayout,
  },
  [AppRoutes.EVENT_CREATE]: {
    path: getRouteEventCreate(),
    element: <NewEvent />,
    authOnly: true,
    layout: MainLayout,
  },
  [AppRoutes.EVENT_DETAILS]: {
    path: getRouteEventDetails(':id'),
    element: <EventPage />,
    authOnly: true,
    layout: MainLayout,
  },
  [AppRoutes.QR]: {
    path: getRouteQr(':id'),
    element: <QrPage />,
  },
  [AppRoutes.INVITE]: {
    path: getRouteInvite(':hash'),
    element: <InvitePage />,
  },
  [AppRoutes.FORM]: {
    path: getRouteForm(':hash'),
    element: <FormPage />,
  },
  [AppRoutes.QR_ADMIN]: {
    path: getRouteQrAdmin(':hash'),
    element: <QrPageAdmin />,
    layout: BasicLayout,
  },
  [AppRoutes.ERROR]: {
    path: getRouteError(),
    element: <ErrorPage />,
    layout: BasicLayout,
  },
  [AppRoutes.ERROR_QR_REMOTE]: {
    path: getRouteErrorQrRemote(),
    element: <ErrorPageForRemote />,
    layout: BasicLayout,
  },
  [AppRoutes.UNCAUGHT_ERROR]: {
    path: getRouteUncaughtError(),
    element: <ErrorPageUncaughtError />,
    layout: BasicLayout,
  },
  [AppRoutes.UNKNOWN_ERROR]: {
    path: getRouteUnknownError(),
    element: <UnknownErrorPage />,
  },
  [AppRoutes.NOT_FOUND]: {
    path: '*',
    element: <NotFoundPage />,
    layout: BasicLayout,
  },
};
